import { memo } from "react";
import { enumNever } from "src/shared/helpers/generalHelpers";
import GatheringHeaderRegular from "./components/GatheringHeaderRegular";
import GatheringHeaderWide from "./components/GatheringHeaderWide/GatheringHeaderWide";
import { GatheringHeaderProps } from "./types";

const GatheringHeader = <TItem extends any>({
	variant = "Regular",
	...props
}: GatheringHeaderProps<TItem> & {
	wheelData?: TItem[];
}) => {
	switch (variant) {
		case "Regular":
			return <GatheringHeaderRegular {...props} />;
		case "Wide":
			return <GatheringHeaderWide {...props} />;
		default:
			return enumNever(variant);
	}
};
export default memo(GatheringHeader) as typeof GatheringHeader;
